import { RouteType } from "types/RouteType";
import llmProvidersRoute from "./LlmProviders/llmProviders.Route";
import llmRoutingRoute from "./LlmRouting/llmRouting.Route";
import llmUsageRoute from "./LlmUsage/llmUsage.Route";

const aiRoutesList: RouteType[] = [
  ...llmProvidersRoute,
  ...llmRoutingRoute,
  ...llmUsageRoute,
];

export default aiRoutesList;
